import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

export default function BlogSection() {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchBlogs = async () => {
            setLoading(true);
            try {
                const res = await axios.get("https://hotel.southtravels.com/api/blogs");
                const data = res.data;
                setBlogs(data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogs();
    }, []);

    return (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12">

            {/* Header */}
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-8">

                <div>
                    <h2 className="text-2xl sm:text-3xl font-bold text-gray-800">
                        Latest Travel Blogs
                    </h2>
                    <p className="text-gray-500 text-sm sm:text-base">
                        Tips, guides & inspiration for your next trip
                    </p>
                </div>

                {/* Desktop Button (ONLY SM AND UP) */}
                <button
                    onClick={() => navigate("/blogs")}
                    className="hidden sm:block bg-gray-900 text-white px-5 py-2.5 rounded-lg hover:bg-gray-700 transition"
                >
                    View All
                </button>
            </div>

            {/* Loader */}
            {loading ? (
                <div className="flex flex-col justify-center items-center py-20 gap-4">
                    <div className="animate-spin rounded-full h-12 w-12 border-4 border-teal-500 border-t-transparent"></div>
                    <p className="text-gray-500">Loading blogs...</p>
                </div>
            ) : blogs.length > 0 ? (
                <>
                    {/* Blogs Grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">

                        {blogs.slice(0, 3).map((blog) => (
                            <div
                                key={blog.id}
                                className="bg-white rounded-xl shadow hover:shadow-lg transition overflow-hidden group"
                            >
                                {/* Image */}
                                <Link to={`/blogs/${blog.slug}`}>
                                    <div className="relative h-44 sm:h-48 overflow-hidden">
                                        <img
                                            src={blog.thumbnail_image}
                                            alt={blog.title}
                                            className="w-full h-full object-cover group-hover:scale-105 transition duration-300"
                                        />

                                        <span className="absolute top-3 left-3 bg-gradient-to-r from-teal-500 to-blue-500 text-white text-[10px] sm:text-xs px-3 py-1 rounded-full">
                                            {blog.category?.name}
                                        </span>
                                    </div>
                                </Link>

                                {/* Content */}
                                <div className="p-4 sm:p-5">
                                    <Link to={`/blogs/${blog.slug}`}>
                                        <h3 className="font-semibold text-base sm:text-lg text-gray-800 line-clamp-2 hover:text-blue-600 transition">
                                            {blog.title}
                                        </h3>
                                    </Link>

                                    <p className="text-gray-500 text-sm mt-2 line-clamp-3">
                                        {blog.excerpt}
                                    </p>

                                    {/* Footer */}
                                    <div className="mt-4 flex justify-between items-center">
                                        <span className="text-xs text-gray-400">
                                            {new Date(blog.created_at).toDateString()}
                                        </span>

                                        <Link
                                            to={`/blogs/${blog.slug}`}
                                            className="text-sm font-medium bg-gradient-to-r from-teal-500 to-blue-500 bg-clip-text text-transparent hover:underline"
                                        >
                                            Read More →
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>

                    {/* ✅ MOBILE BUTTON (BOTTOM ONLY) */}
                    <div className="mt-8 sm:hidden">
                        <button
                            onClick={() => navigate("/blogs")}
                            className="w-full bg-gray-900 text-white px-5 py-3 rounded-lg hover:bg-gray-700 transition"
                        >
                            View All
                        </button>
                    </div>
                </>
            ) : (
                <p className="text-gray-500">No blogs found</p>
            )}
        </section>
    );
}